import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import $ from "jquery";
import { Row, Col, Card, Button, Modal, Spinner } from "react-bootstrap";

import PsContext from "../../../context/PsContext";
import API from "../../../utils/API";
import { upperCase } from "../../../utils";
import { toast } from "react-hot-toast";
import FeaturedProduct from "../../elements/Products/Featured";
import ProductLoader from "../Home/productLoader";
import NO_PRODUCT_IMG from "../../../assets/img/empty.webp";
import FilterSidebar from "../Category/catFilter";

const NewArraivalsMenu = (props) => {
  const context = useContext(PsContext);
  const [initialLoader, setInitialLoader] = useState(true);
  const [filterLoader, setFilterLoader] = useState(false);
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [filters, setFilters] = useState({});
  const [activeClass, setActiveClass] = useState("normal");
  const [wishlistItems, setWishlistItems] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const slug = props.match.params.name;
  const [filterCounts, setFilterCounts] = useState({
    color: {},
    size: {},
    offerOnly: 0,
  });

  const handleSortChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      sortBy: value,
    }));
  };

  /* 
  ==============Filter with sorting =============
  */
  const handleFilterChange = (type, value) => {
    let formattedValue;

    if (type === "minPrice" || type === "maxPrice") {
      formattedValue = parseFloat(value || 0).toFixed(2);
    } else if (type === "color" || type === "size") {
      formattedValue = value;
    } else {
      formattedValue = value;
    }

    // Update filter state
    setFilters((prev) => ({
      ...prev,
      [type]: formattedValue,
    }));
  };

  useEffect(() => {
    let curProducts = [...allProducts];
    const counts = {
      color: {},
      size: {},
      offerOnly: 0,
    };

    allProducts.forEach((item) => {
      if (item.color) {
        item.color.split(",").forEach((color) => {
          const key = color.trim().toLowerCase();
          if (key) counts.color[key] = (counts.color[key] || 0) + 1;
        });
      }
      if (item.i_size) {
        const sizeStr = item.i_size.toUpperCase().replace(/\s/g, "");
        counts.size[sizeStr] = (counts.size[sizeStr] || 0) + 1;
      }

      if (parseFloat(item.salesdiscount) > 0) {
        counts.offerOnly++;
      }
    });

    setFilterCounts(counts);
    // console.log("Filter Counts:", counts);

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== "" && value.length !== 0) {
        if (key === "minPrice") {
          curProducts = curProducts.filter(
            (item) => parseFloat(item.salesrate) > value
          );
        } else if (key === "maxPrice") {
          curProducts = curProducts.filter(
            (item) => parseFloat(item.salesrate) < value
          );
        } else if (key === "color" && Array.isArray(value)) {
          curProducts = curProducts.filter((item) =>
            value.some(
              (color) =>
                item.color &&
                item.color.toLowerCase().includes(color.toLowerCase())
            )
          );
        } else if (key === "size" && Array.isArray(value)) {
          curProducts = curProducts.filter((item) =>
            value.some((size) => {
              const [minSize, maxSize] = size
                .split("-")
                .map((s) => parseInt(s));
              const sizeValue = item.i_size;

              if (!sizeValue) return false;

              if (sizeValue.includes("TO")) {
                const [rangeStart, rangeEnd] = sizeValue
                  .split("TO")
                  .map((s) => parseInt(s.trim()));
                return rangeStart <= maxSize && rangeEnd >= minSize;
              } else {
                const parsedSize = parseInt(sizeValue.trim());
                return parsedSize >= minSize && parsedSize <= maxSize;
              }
            })
          );
        } else if (key === "offerOnly" && value === true) {
          curProducts = curProducts.filter(
            (item) => parseFloat(item.salesdiscount) > 0
          );
        }
      }
    });

    const isAllEmpty =
      (!filters.minPrice || filters.minPrice === "0.00") &&
      (!filters.maxPrice || filters.maxPrice === "0.00") &&
      (!filters.color || filters.color.length === 0) &&
      (!filters.size || filters.size.length === 0) &&
      !filters.sortBy &&
      !filters.offerOnly;

    if (isAllEmpty) {
      curProducts = [...allProducts];
    }

    if (filters.sortBy) {
      switch (filters.sortBy) {
        case "a-z":
          curProducts.sort((a, b) =>
            (a.itemname || "").localeCompare(b.itemname || "")
          );
          break;
        case "z-a":
          curProducts.sort((a, b) =>
            (b.itemname || "").localeCompare(a.itemname || "")
          );
          break;
        case "price-low-high":
          curProducts.sort(
            (a, b) => parseFloat(a.salesrate) - parseFloat(b.salesrate)
          );
          break;
        case "price-high-low":
          curProducts.sort(
            (a, b) => parseFloat(b.salesrate) - parseFloat(a.salesrate)
          );
          break;
        case "date-old-new":
          curProducts.sort((a, b) => new Date(a.idate) - new Date(b.idate));
          break;
        case "date-new-old":
          curProducts.sort((a, b) => new Date(b.idate) - new Date(a.idate));
          break;
        default:
          break;
      }
    }

    setProducts(curProducts);
  }, [filters, allProducts]);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setActiveClass(window.scrollY === 0 ? "normal" : "top");
    });
  }, []);
  /* 
  ==============All Products=============
  */
  const loadProducts = async (isInitialLoad = false) => {
    if (isInitialLoad) {
      setInitialLoader(true);
    } else {
      setFilterLoader(true);
    }

    try {
      let url = `/v1/site/news`;
      const res = await API.get(url);
      if (res.data.status === "1") {
        setProducts(res.data.data);
        setAllProducts(res.data.data);
      } else {
        setProducts([]);
      }
    } catch (err) {
      console.error("Error loading products:", err);
      setProducts([]);
    } finally {
      setInitialLoader(false);
      setFilterLoader(false);
    }
  };
  useEffect(() => {
    setProducts([]);
    setFilters({
      minPrice: undefined,
      maxPrice: undefined,
      brand: undefined,
      color: undefined,
      inStock: undefined,
      sortBy: undefined,
      offerOnly: undefined,
    });
    bodyToTop();
    loadProducts(true);
  }, [slug]);

  const bodyToTop = () => {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  };

  useEffect(() => {
    const user = localStorage.getItem("customerData");
    if (user) {
      context.setState({ ...context.state, userData: JSON.parse(user) });
    }
  }, []);

  const fetchWishlistItems = async () => {
    try {
      const customerid = context.state.userData.id;
      if (customerid) {
        const res = await API.get(`v1/site/whishlist/list/${customerid}`);
        if (res.data.status === "1") {
          const ids = res.data.data.map((item) => item.id);
          setWishlistItems(ids);
        }
      }
    } catch (err) {
      console.error("Error fetching wishlist:", err);
    }
  };
  useEffect(() => {
    fetchWishlistItems();
  }, []);

  const addToCart = (id) => {
    const dat = products.find((item) => item.id === id);
    if (dat) {
      dat.quantity = 1;
      context.addToCart(dat);
      toast.success("Successfully added to cart!");
    }
  };

  const toggleWishlist = async (itemid) => {
    const customerid =
      context.state.userData.id ||
      JSON.parse(localStorage.getItem("customerData") || "{}").id;

    if (!customerid) {
      toast.error("Please login to manage your wishlist.");
      return;
    }

    const isInWishlist = wishlistItems.includes(itemid);
    const postData = new FormData();
    postData.append("customerid", customerid);
    postData.append("itemid", itemid);

    try {
      if (isInWishlist) {
        const res = await API.post("v1/site/whishlist/delete", postData);
        if (res.data.status === "1") {
          setWishlistItems((prev) => prev.filter((id) => id !== itemid));
          toast.success("Removed from wishlist.");
        } else {
          toast.error(res.data.message || "Error removing from wishlist.");
        }
      } else {
        const res = await API.post("v1/site/whishlist/add", postData);
        if (res.data.status === "1") {
          setWishlistItems((prev) =>
            prev.includes(itemid) ? prev : [...prev, itemid]
          );
          toast.success("Added to wishlist.");
        } else {
          toast.error(res.data.message || "Error adding to wishlist.");
        }
      }
    } catch (error) {
      console.error("Wishlist error:", error);
      toast.error("Something went wrong.");
    }
  };

  return (
    <>
      <div className="tf-page-title">
        <div className="container-full">
          <div className="heading text-center">New Arrival</div>
          <p className="text-center text-2 text_black-2 mt_5">
            Grab the Latest Products Now
          </p>
        </div>
      </div>

      <div className=" container-fluid my-3">
        <Row className="gutters-3">
          <Col md={3} className="scroll-1">
            <FilterSidebar
              slug={slug}
              onFilterChange={handleFilterChange}
              setAllProducts={setAllProducts}
              filterCounts={filterCounts}
            />
          </Col>

          <Col md={9} className="col-md-9  scroll-2">
            <div className="tf-control-sorting d-flex justify-content-end mb-3  scroll-3">
              <div className="tf-dropdown-sort dropdown">
                <div
                  className="btn-select dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span className="text-sort-value">
                    {filters.sortBy || "Featured"}
                  </span>
                </div>
                <div className="dropdown-menu show-on-hover">
                  {[
                    { label: "Alphabetically, A-Z", value: "a-z" },
                    { label: "Alphabetically, Z-A", value: "z-a" },
                    { label: "Price, low to high", value: "price-low-high" },
                    { label: "Price, high to low", value: "price-high-low" },
                    { label: "Date, old to new", value: "date-old-new" },
                    { label: "Date, new to old", value: "date-new-old" },
                  ].map((opt) => (
                    <div
                      key={opt.value}
                      className="select-item dropdown-item"
                      onClick={() => handleSortChange(opt.value)}
                    >
                      <span className="text-value-item text-dark">
                        {opt.label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {initialLoader && <ProductLoader size={8} />}
            {filterLoader && (
              <div className="text-center my-4">
                <Spinner animation="border" size="sm" />
                <span className="ml-2">Loading filtered products...</span>
              </div>
            )}

            <Row>
              {!initialLoader &&
                !filterLoader &&
                products.map((item) => (
                  <Col
                    xs={6}
                    sm={6}
                    md={3}
                    key={item.id}
                    className="card-product mb-3"
                  >
                    <FeaturedProduct
                      title={item.itemname}
                      image={item.image}
                      image1={item.image1}
                      id={item.id}
                      height="320px"
                      item={item}
                      amount={
                        item.salesdiscount > 0
                          ? item.discount_sales_rate
                          : item.salesrate
                      }
                      addToCart={() => addToCart(item.id)}
                      addToWishlist={() => toggleWishlist(item.id)}
                      isInWishlist={wishlistItems.includes(item.id)}
                    />
                  </Col>
                ))}
            </Row>

            {!initialLoader && !filterLoader && products.length === 0 && (
              <center>
                <br />
                <br />
                <img
                  style={{ width: "100%", maxWidth: "300px" }}
                  src={NO_PRODUCT_IMG}
                  alt="No Products"
                />
                <h4 className="mt-5" style={{ fontSize: "20px" }}>
                  SORRY! WE COULDN'T FIND ANY PRODUCTS
                </h4>
              </center>
            )}
          </Col>
        </Row>

        <div className={`mobile-drawer ${showFilter ? "open" : ""}`}>
          <div
            className="mobile-drawer-overlay tf-lg-hidden"
            onClick={() => setShowFilter(false)}
          ></div>
          <div className="mobile-drawer-sidebar">
            <div className="text-end p-2 mb-30">
              <button
                className="btn-close bg-transparent5 border-0 w-100"
                onClick={() => setShowFilter(false)}
                style={{
                  background: "white",
                  position: "absolute",
                  right: "-110px",
                }}
              >
                <span className="icon-close"></span>
              </button>
            </div>
            <FilterSidebar
              slug={slug}
              onFilterChange={handleFilterChange}
              setAllProducts={setAllProducts}
              allProducts={allProducts}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(NewArraivalsMenu);
